import { useNavigate } from 'react-router-dom';
import { Avatar, Badge, Button } from '../../../components/ui';
import { activeFilter, whatsapp } from '../../../components/common/ListPage/listFilters';
import { Cell, ListPage } from '../../../components/common/ListPage/ListPage';

export default function CustomerList() {
  const navigate = useNavigate();
  const add = <Button leftIcon="plus" onClick={() => navigate('/customers/new')}>Add customer</Button>;
  return (
    <ListPage
      title="Customers"
      path="/customers"
      filters={[activeFilter]}
      searchPlaceholder="Name, phone or city"
      actions={add}
      rowTo={(c) => `/customers/${c._id}`}
      rowActions={(c) =>
        [
          { label: 'View', icon: 'eye', onClick: () => navigate(`/customers/${c._id}`) },
          { label: 'Edit', icon: 'edit', onClick: () => navigate(`/customers/${c._id}/edit`) },
          { label: 'New quotation', icon: 'quote', onClick: () => navigate(`/quotations/new?customerId=${c._id}`) },
          { label: 'New service job', icon: 'wrench', onClick: () => navigate(`/jobs/new?customerId=${c._id}`) },
          c.phone && { label: 'Send on WhatsApp', icon: 'send', onClick: () => whatsapp(c.phone, `Hello ${c.name},`) },
        ].filter(Boolean)
      }
      columns={[
        {
          header: 'Customer', sort: 'name',
          render: (c) => (
            <span className="flex items-center gap-3">
              <Avatar name={c.name} size={32} />
              <Cell title={c.name} sub={c.customerCode} mono />
            </span>
          ),
          csv: (c) => c.name,
        },
        { header: 'Code', sort: 'customerCode', render: (c) => c.customerCode, csv: (c) => c.customerCode, defaultHidden: true },
        { header: 'Phone', sort: 'phone', render: (c) => <span className="tabular">{c.phone || '-'}</span>, csv: (c) => c.phone },
        { header: 'City', sort: 'billingAddress.city', render: (c) => c.billingAddress?.city || <span className="text-ink-300">-</span>, csv: (c) => c.billingAddress?.city },
        { header: 'Type', sort: 'customerType', render: (c) => <Badge tone={c.customerType === 'business' ? 'blue' : 'neutral'}>{c.customerType === 'business' ? 'Business' : 'Individual'}</Badge>, csv: (c) => c.customerType },
        { header: 'GSTIN', sort: 'gstin', render: (c) => <span className="font-mono text-xs">{c.gstin || '-'}</span>, csv: (c) => c.gstin, defaultHidden: true },
        { header: 'Status', sort: 'isActive', render: (c) => (c.isActive ? <Badge tone="green" dot>Active</Badge> : <Badge tone="grey" dot>Inactive</Badge>), csv: (c) => (c.isActive ? 'Active' : 'Inactive') },
      ]}
      mobile={(c) => ({
        title: c.name,
        subtitle: [c.phone, c.billingAddress?.city].filter(Boolean).join(', ') || c.customerCode,
        badge: !c.isActive && <Badge tone="grey">Inactive</Badge>,
      })}
      empty={{ icon: 'users', title: 'No customers yet', message: 'Add your first customer to start making quotations.', action: add }}
    />
  );
}
